import { AlertCircle } from 'lucide-react'

import type { ErrorKind } from './classifyError'
import styles from './ErrorBanner.module.css'

/**
 * ErrorBanner — inline error row rendered inside <SearchDropdown /> when the
 * `useSearch` hook surfaces an ApiError (UI-SPEC §Components 7 + §Copywriting
 * line 177).
 *
 * Copy sourced from UI-SPEC verbatim. The Fuzzy-Search + budget + upstream
 * band share a single user-facing string per UI-SPEC §Copywriting; the auth
 * and unknown bands fall through to conservative defaults not in UI-SPEC but
 * implied by D-83 + §ARIA roles summary (line 533 — `alert` transient).
 *
 * T-2-PROB: never renders TomTom detail bodies — only the four discrete bands
 * produced by `classifyError`.
 */

export interface ErrorBannerProps {
  kind: ErrorKind
}

const COPY: Record<ErrorKind, string> = {
  // UI-SPEC §Copywriting row "Search error (429 budget / 502 upstream)".
  budget: 'Search temporarily unavailable. Please try again later.',
  upstream: 'Search temporarily unavailable. Please try again later.',
  auth: 'Session expired. Sign in again.',
  unknown: 'Something went wrong. Please try again.',
}

export function ErrorBanner({ kind }: ErrorBannerProps) {
  return (
    <div role="alert" className={styles.banner}>
      <AlertCircle size={16} strokeWidth={2} className={styles.icon} aria-hidden="true" />
      <span className={styles.body}>{COPY[kind]}</span>
    </div>
  )
}
